import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function WalletHistory() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [history,
    setHistory] =
    useState([]);

  const [search,
    setSearch] =
    useState("");

  useEffect(() => {

    loadHistory();

  }, []);

  const loadHistory =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            `/wallets/history/${id}`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setHistory(
          res.data.history || []
        );

      } catch (err) {

        console.log(err);

      }

    };

  const filtered =
    history.filter(item =>
      item.description
        ?.toLowerCase()
        .includes(
          search.toLowerCase()
        )
    );

  const badge =
    (type) => {

      switch (type) {

        case "credit":

          return "bg-green-500";

        case "debit":

          return "bg-red-500";

        default:

          return "bg-blue-500";

      }

    };

  const amountColor =
    (type) => {

      switch (type) {

        case "credit":

          return "text-green-400";

        case "debit":

          return "text-red-400";

        default:

          return "text-blue-400";

      }

    };

  return (

    <div>

      <div
        className="
        flex
        justify-between
        items-center
        flex-wrap
        gap-4
        mb-6
        "
      >

        <h1
          className="
          text-4xl
          font-bold
          "
        >
          Wallet History
        </h1>

        <button
          onClick={() =>
            navigate(
              "/admin/wallets"
            )
          }
          className="
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
          "
        >
          Back
        </button>

      </div>

      {/* Search */}

      <input
        placeholder="Search..."
        value={search}
        onChange={(e)=>
          setSearch(
            e.target.value
          )
        }
        className="
        w-full
        md:w-96
        p-3
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        mb-6
        "
      />

      {/* Mobile */}

      <div
        className="
        md:hidden
        space-y-4
        "
      >

        {filtered.map(
          (item)=>(
            <div
              key={item.id}
              className="
              bg-[#111]
              rounded-2xl
              p-5
              border
              border-yellow-500/10
              "
            >

              <div
                className="
                flex
                justify-between
                items-center
                "
              >

                <span
                  className={`
                  px-3
                  py-1
                  rounded-full
                  text-sm
                  ${badge(item.transaction_type)}
                  `}
                >
                  {
                    item.transaction_type
                  }
                </span>

                <span
                  className={`
                  text-xl
                  font-bold
                  ${amountColor(item.transaction_type)}
                  `}
                >
                  ₹
                  {
                    Number(item.amount)
                    .toFixed(2)
                  }
                </span>

              </div>

              <p
                className="
                mt-4
                "
              >
                {
                  item.description
                }
              </p>

              <p
                className="
                mt-3
                text-gray-400
                text-sm
                "
              >
                {
                  new Date(
                    item.created_at
                  ).toLocaleString()
                }
              </p>

            </div>
          )
        )}

      </div>

      {/* Desktop */}

      <div
        className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
      >

        <div
          className="
          overflow-x-auto
          "
        >

          <table
            className="
            w-full
            "
          >

            <thead>

              <tr
                className="
                border-b
                border-yellow-500/20
                "
              >

                <th className="p-4 text-left">
                  Type
                </th>

                <th className="p-4 text-left">
                  Amount
                </th>

                <th className="p-4 text-left">
                  Wallet Amount
                </th>

                <th className="p-4 text-left">
                  Description
                </th>

                <th className="p-4 text-left">
                  Date
                </th>

              </tr>

            </thead>

            <tbody>

              {filtered.map(
                item=>(
                  <tr
                    key={item.id}
                    className="
                    border-b
                    border-yellow-500/10
                    "
                  >

                    <td className="p-4">

                      <span
                        className={`
                        px-3
                        py-1
                        rounded-full
                        ${badge(item.transaction_type)}
                        `}
                      >
                        {
                          item.transaction_type
                        }
                      </span>

                    </td>

                    <td
                      className={`
                      p-4
                      font-bold
                      ${amountColor(item.transaction_type)}
                      `}
                    >
                      ₹
                      {
                        Number(item.amount)
                        .toFixed(2)
                      }
                    </td>

                    <td
                      className={`
                      p-4
                      font-bold
                      text-green-400
                      `}
                    >
                      ₹
                      {
                        Number(item.current_amount)
                        .toFixed(2)
                      }
                    </td>

                    <td className="p-4">
                      {
                        item.description
                      }
                    </td>

                    <td className="p-4">
                      {
                        new Date(
                          item.created_at
                        ).toLocaleString()
                      }
                    </td>

                  </tr>
                )
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

}

export default WalletHistory;